export default __webpack_public_path__ + "static/media/guide_043.ce1ab2c7.md";